import { Sensors, SensorType } from "../../types/sensors";
import { CalculationResult } from "../../types/calculations";
import { SENSOR_TYPES, calculateSensorCost, calculateSensorTons, calculateSensorPower } from "../../constants/sensors";

export interface SensorStats {
  cost: number;
  tons: number;
  power: number;
}

export const calculateSensorStats = (
  sensors: Sensors,
  shipSize: number,
): CalculationResult<SensorStats> => {
  if (!sensors || !sensors.type) {
    return {
      success: false,
      error: {
        type: "INVALID_INPUT",
        message: "Sensor type must be selected.",
      },
    };
  }

  const sensorSpec = SENSOR_TYPES[sensors.type as SensorType];

  if (!sensorSpec) {
    return {
      success: false,
      error: {
        type: "CALCULATION_ERROR",
        message: `Invalid sensor type: ${sensors.type}`,
      },
    };
  }

  // Use the proper calculation functions that handle scaling correctly
  const cost = calculateSensorCost(sensors.type as SensorType, shipSize);
  const tons = calculateSensorTons(sensors.type as SensorType, shipSize);
  const power = calculateSensorPower(sensors.type as SensorType, shipSize);

  return {
    success: true,
    data: {
      cost,
      tons,
      power,
    },
  };
};
